export class DevUtils {
  public static readonly DEV_ENVIRONMENT_NAME = 'development';

  static isLocalEnvironment(env: NodeJS.ProcessEnv): boolean {
    return env.NODE_ENV === this.DEV_ENVIRONMENT_NAME;
  }
}
